import { render } from "./FoerderorganisationDetails.pug?vue&type=template&id=9515c04e&lang=pug"
import script from "./FoerderorganisationDetails.js?vue&type=script&lang=js"
export * from "./FoerderorganisationDetails.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__